const LOGIN = process.env.VUE_APP_STORAGE_LOGIN;
const CONNECTED = process.env.VUE_APP_STORAGE_CONNECTED;

const baseApiUrl = process.env.VUE_APP_API_URL;

console.log('api', baseApiUrl);

import axios from 'axios';

export default {
  state: {
    login: sessionStorage.getItem(LOGIN) || '',
    connected: sessionStorage.getItem(CONNECTED) || false,
    urlBase: sessionStorage.getItem(CONNECTED)
      ? baseApiUrl + '/authenticated/'
      : baseApiUrl + '/public/',
  },
  getters: {
    isLoggedIn: state => !!state.connected,
    getLogin: state => state.login,
    getUrlBase: state => state.urlBase,
    getConnected: state => state.connected,
  },
  mutations: {
    auth_request(state) {
      state.login = '';
    },
    auth_success(state) {
      state.connected = true;
      state.urlBase = baseApiUrl + '/authenticated/';
    },
    set_login(state, login) {
      state.login = login;
    },
    auth_error(state) {
      state.connected = false;
      state.login = '';
      state.urlBase = baseApiUrl + '/public/';
    },
    logout(state) {
      state.connected = false;
      state.login = '';
      state.urlBase = baseApiUrl + '/public/';
    },
  },
  actions: {
    login({ commit, dispatch }) {
      commit('logout');

      const baseMessage = 'Error during login';

      return new Promise((resolve, reject) => {
        axios
          .get(baseApiUrl + '/authenticated/user')
          .then(
            // eslint-disable-next-line arrow-parens
            resp => {
              const data = resp.data;
              console.log(data.id);
              if ('id' in data) {
                sessionStorage.setItem(LOGIN, data.id);
                console.log(data.id);
                sessionStorage.setItem(CONNECTED, true);
                commit('auth_success');
                commit('set_login', data.id);
              } else {
                commit('logout');
              }

              resolve(resp);
            },
            err => {
              commit('auth_error');
              commit('setErrored', true, { root: true });
              let message = err.response.data.message
                ? baseMessage + ': ' + err.response.data.message
                : baseMessage;
              commit('setErrorMsg', message, { root: true });

              commit('logout');
              sessionStorage.removeItem(LOGIN);
              sessionStorage.removeItem(CONNECTED);
              reject(err);
            }
          )
          .finally(() => dispatch('fetchListOfSpecies'))
          .catch(() => {
            commit('setErrored', true, { root: true });
            commit('setErrorMsg', baseMessage, { root: true });
            reject();
          });
      });
    },
    logout({ commit, dispatch }) {
      const baseMessage = 'Error during logout';

      return new Promise((resolve, reject) => {
        axios
          .get(baseApiUrl + '/logout')
          .then(
            resp => {
              sessionStorage.removeItem(LOGIN);
              sessionStorage.removeItem(CONNECTED);
              commit('logout');
              resolve(resp);
            },
            err => {
              commit('setErrored', true, { root: true });
              let message = err.response.data.message
                ? baseMessage + ': ' + err.response.data.message
                : baseMessage;
              commit('setErrorMsg', message, { root: true });
              commit('logout');
              sessionStorage.removeItem(LOGIN);
              sessionStorage.removeItem(CONNECTED);
              reject(err);
            }
          )
          .finally(() => dispatch('fetchListOfSpecies'))
          .catch(() => {
            commit('setErrored', true, { root: true });
            commit('setErrorMsg', baseMessage, { root: true });

            reject();
          });
      });
    },
  },
};
